import { render, staticRenderFns } from "./PersonRoles.vue?vue&type=template&id=057dc324"
import script from "./PersonRoles.vue?vue&type=script&lang=js"
export * from "./PersonRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports